/***
 * Created on 2023/11/28
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

export const ErrorCode = {
    "1000001": "@System busy please try again later@",
    "1000003": "@Invalid format@",
    "1004003": "@Wrong code. Try again.@",
    "1004004": "@Invalid verification code@",
    "1004005": "@Invalid verification code@",
    "1004006": "@User already exist@",
    "1004010": "@Verification code was not send due to daily SMS limit was reached. Please wait a day or use other authentication methods.@",
    "1004015": "@Invalid QNAP Authenticator passcode or missing.@",
    "1004025": "@The 2-step verification code can only be used once. Please wait for a new code and try again.@",
    "1007004": "@Invitation not found.@",
    "1010007": "@Login Failed too many times, account locked.@",
    "1019012": "@Please select a country@",
    "1012005": "@Cannot find your account in current region@",
    "1012006": "@Invalid Password@",
    "1012007": "@User not activated@",
    "1012010": "@You have entered an old password. Please use your latest password.@",
    "1013001": "@Invalid Access Token@",
    "1013003": "@User has not linked {platform} @",
    "1013004": "@Your Facebook token is invalid, please sign up with Facebook again.@",
    "1013005": "@Fail to verify your account with Google. Please sign up with other way.@",
    "1013006": "@Your Google token is invalid, please sign up with Google again.@",
    "1013007": "@To Retrive User Avatar from Google Failed@",
    "1019000": "@Captcha is incorrect@",
    "1019007": "@Login Failed too many times, account locked.@",
    "1019010": "@It looks like you have tried too many times. Try again later.@",
    "1019011": "@Unable to sign in a different region@",
    "1019014": "@Captcha is incorrect@",
    "1019017": "@reCaptcha token expired, please try again.@",
    "1050001": "@User not found@",
    "1050002": "@User already exist@",
    "1050020": "@User already exist@",
    "1050003": "@User already exist@",
    "1050005": "@Incorrect password@",
    "1050006": "@Account has been activated@",
    "1050009": "@Unsupported image type@",
    "1050010": "@Cannot read image file@",
    "1050011": "@User has not linked {platform} @",
    "1050012": "@The platform {platform} has been linked@",
    "1050015": "@QID does not accept sign up using this domain@",
    "1050017": "@Invalid revoke token@",
    "1050022": "@QID not verified@",
    "1050026": "@Your {social_network} account has already been registered in QNAP. Due to allow {social_network1} login has disabled in your profile, please enter the QNAP ID and password to login.@",
    "1050027": "@User did not meet the age restriction@",
    "1050032": "@Must not be the same as your last 5 passwords used.@",
    "1050031": "@Appleid Auth Code Revoked, try login again.@",
    "1050039": "@You are only allowed to change your email address once every three months.@",
    "1060001": "@Unable to create Organization.@",
    "1060002": "@Organization name {org_name} is already taken.@",
    "1060003": "@Organization not found or Invalid Organization ID.@",
    "1060004": "@Permission denied. Need to be owner to complete the operation.@",
    "1060005": "@User(s) does not exists in the Organization.@",
    "1060006": "@Cannot delete self as a owner of the organization.@",
    "1060007": "@Cannot delete the only owner in organization.@",
    "1060008": "@Unable to create Organization Group.@",
    "1060009": "@Organization group name {group_name} is already taken.@",
    "1060010": "@Organization max owner number reached.@",
    "1060011": "@Organization needs to have at least one owner.@",
    "1060012": "@User already exists in the Organization.@",
    "1060013": "@Missing Organization ID or invalid token.@",
    "1060014": "@User does not have an email in the profile.@",
    "1060015": "@Invalid Group ID or Group not found.@",
    "1060016": "@The requested organization id does not match with the current token Organization Id@",
    "1060017": "@The token contains neither Organization ID nor User info.@",
    "1060018": "@Site duplicate@",
    "1060019": "@Invalid Site ID or Site not found.@",
    "1060020": "@User were not in the Organization.@",
    "1060021": "@Group were not in the Organization.@",
    "1060022": "@You cannot suspend your own account from the owner group.@",
    "1129005": "@Login failed.@",
    "1190006": "@Device auth existed@",
    "1019016": "@Captcha is incorrect@",
    "captcha": "@Captcha is incorrect@",
    "oauth_auth_sso_enforced": "@Your organization requires SSO login. Please sign in using SAML SSO.@",
    "qid_format_error": "@Invalid email or phone formate.@",
    "qid_empty": "@You can't leave this empty.@",
    "sms_unsupported": "@myQNAPcloud dosen not support SMS service in your country, use email to create an account.@",
    "field_required": "@You can't leave this empty.@",
    "invalid_format": "@Invalid format@",
    "default_error": "@Error@"
}